import React, { useEffect, useState, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import CategoriesPage from './pages/CategoriesPage';
import ProductPage from './pages/ProductPage';
import SellerPage from './pages/SellerPage';
import FAQPage from './pages/FAQPage';
import ShippingPage from './pages/ShippingPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
export function App() {
  // Listen for custom events from ProductCard components
  useEffect(() => {
    const headerElement = document.querySelector('header');
    if (headerElement) {
      const handleAddToCart = event => {
        // Find all buttons with the ShoppingCartIcon class
        const cartButtons = document.querySelectorAll('header button');
        cartButtons.forEach(button => {
          const svg = button.querySelector('svg');
          if (svg && svg.classList.contains('lucide-shopping-cart')) {
            // Simulate a click on the cart button to show the dropdown
            const cartBadge = button.querySelector('span');
            if (cartBadge) {
              const currentCount = parseInt(cartBadge.textContent || '0');
              cartBadge.textContent = (currentCount + 1).toString();
            } else {
              const newBadge = document.createElement('span');
              newBadge.className = 'absolute -top-2 -right-2 bg-green-700 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center';
              newBadge.textContent = '1';
              button.appendChild(newBadge);
            }
          }
        });
      };
      headerElement.addEventListener('addToCart', handleAddToCart);
      return () => {
        headerElement.removeEventListener('addToCart', handleAddToCart);
      };
    }
  }, []);
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/categories" element={<CategoriesPage data-id="element-8" />} data-id="element-7" />
            <Route path="/product/:id" element={<ProductPage data-id="element-10" />} data-id="element-9" />
            <Route path="/become-seller" element={<SellerPage data-id="element-12" />} data-id="element-11" />
            <Route path="/faq" element={<FAQPage data-id="element-14" />} data-id="element-13" />
            <Route path="/shipping" element={<ShippingPage data-id="element-16" />} data-id="element-15" />
            <Route path="/about" element={<AboutPage data-id="element-18" />} data-id="element-17" />
            <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
          </Routes>
        </main>
        <Footer data-id="element-21" />
      </div>
    </Router>;
}